import { Layout } from "providers/Layout";
import { Show } from "shared/components";
import { LayoutHeader } from "./Components/LayoutHeader";
import { LayoutFooter } from "./Components/LayoutFooter";
import { cx } from "shared/utils";
import { PropertyFormProvider } from "./PropertyFormProvider";
import { Property } from "posthog-js";
import { useNavigate } from "react-router-dom";
import { CreatePropertyForm } from "./Components/CreatePropertyForm";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";

interface AddPropertyProps {
  newPropertyName?: string;
  isDrawerContent?: boolean;
  onClose?: () => void;
  onSuccess?: (newProperty?: Property) => void;
}

export const AddProperty = ({ isDrawerContent, onClose }: AddPropertyProps) => {
  const dictionary = useUnitsPropertiesDictionary();
  const navigate = useNavigate();

  return (
    <PropertyFormProvider>
      <Layout
        sectionClassName={cx("space-y-6", isDrawerContent ? "bg-white" : "")}
        headerClassName={isDrawerContent ? "hidden" : ""}
        displayAside={!isDrawerContent}
        header={
          <Show if={!isDrawerContent}>
            <LayoutHeader />
          </Show>
        }
        footer={
          <LayoutFooter
            onCancel={() => (isDrawerContent ? onClose?.() : navigate(-1))}
          />
        }
      >
        <div className="space-y-2">
          <h1 className="text-xl font-bold">{`Add ${dictionary.property} details`}</h1>
          <p className="text-xs text-content-500">
            Add details about your {dictionary.property}, including its name,
            address, and location
          </p>
        </div>

        <CreatePropertyForm />
      </Layout>
    </PropertyFormProvider>
  );
};
